<template>
    <v-form lazy-validation ref="form" @submit.prevent="validate">
      <div class="md-layout-item md-size-95 ml-auto mt-4 md-small-size-100">
        <div class="md-layout">
         <!--  <md-field>
            <label>用户所属群组</label>
            <md-select v-model="user.groupId" multiple>
              <md-option v-for="item of groupListData" :key="item.id" :value="item.id">{{ item.name }}</md-option>
            </md-select>
          </md-field> -->

          <v-select v-model="user.prgroupIdovince" :items="groupListData" item-text="name" item-value="id" label="用户所属群组" v-on:change="changeGroup"></v-select>
        </div>
      </div>
    </v-form >
</template>
<script>
import { groupList } from '@/api/user';
export default {
    data() {
        return {
            groupListData: []
        };
    },
    props: {
        user: {
            type: Object,
            default: () => {},
        },
    },
    components: {
    },
    created () {
        this.groupList();
        // console.log("--------------------->设置页面")
    },
    methods: {
      changeGroup(e){
        this.$emit('prgroupIdovince',e)
      },
        validate() {
            if (this.$refs.form.validate()) {
                this.$emit("on-validated", true);
                return true;
            }
        },
        groupList (params) {
              groupList().then((res) => {
                if (res.code === '200') {
                    this.groupListData = res.data;
                }
            })
        },
        getUser () {
            return this.user;
        }
    },
};
</script>